import React, { useContext, useMemo } from 'react';

import { SET_TABLE_SETTINGS, useScreenDispatch } from '@gogame/screens';

import OrderControl from 'scenes/Gallery/components/OrderControl';

import { ConversionPagesDataTableContext } from 'scenes/Gallery/ConversionPages/ConversionPages/ConversionPagesDataTable';
import { SCOPE_PAGES } from 'scenes/Gallery/ConversionPages/constants';
import {
  COLUMN_ID,
  COLUMN_NAME,
  COLUMN_APPLICATION,
  COLUMN_DOMAIN,
  COLUMN_LOCALE,
  COLUMN_FLOW,
  COLUMN_USED_IN_ADS,
  COLUMN_PLATFORM,
  COLUMN_CREATED_DATE,
} from 'scenes/Gallery/ConversionPages/ConversionPages/ConversionPagesDataTable/constants';

export default () => {
  const { tableSettings } = useContext(ConversionPagesDataTableContext);
  const dispatch = useScreenDispatch();

  const orderDirectionAsc = tableSettings.orderDir === 'asc';

  const handleChangeSettings = (id) => () => {
    dispatch({
      type: SET_TABLE_SETTINGS,
      scope: SCOPE_PAGES,
      payload: {
        ...tableSettings,
        orderBy: id,
        orderDir:
          tableSettings.orderBy !== id || orderDirectionAsc ? 'desc' : 'asc',
      },
    });
  };

  const SORTED_COLUMNS_LIST = useMemo(() => {
    return [
      { id: COLUMN_ID, name: 'ID' },
      { id: COLUMN_NAME, name: 'Name' },
      { id: COLUMN_APPLICATION, name: 'Application' },
      { id: COLUMN_DOMAIN, name: 'Domain' },
      { id: COLUMN_LOCALE, name: 'Locale' },
      { id: COLUMN_FLOW, name: 'Flow' },
      { id: COLUMN_USED_IN_ADS, name: 'Used in Ads' },
      { id: COLUMN_PLATFORM, name: 'Platform' },
      { id: COLUMN_CREATED_DATE, name: 'Created' },
    ];
  }, []);

  return (
    <OrderControl
      sortedColumnList={SORTED_COLUMNS_LIST}
      onChange={handleChangeSettings}
      orderDirectionAsc={orderDirectionAsc}
      orderBy={tableSettings.orderBy}
    />
  );
};
